<div [formGroup]="form">
  <p>{{'additionalInformationEtc'| preventHardcoding}}</p>
  <app-text-editor [textFormControl]="description" textEditorFormControlName="description">{{'writeTheRelevantInformation'| preventHardcoding}}</app-text-editor>
  <div>
    <mat-checkbox color="primary" formControlName="exclude">{{'excludeFromCV'| preventHardcoding}}</mat-checkbox>
  </div>
</div>
